const JerseySvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111671)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M35.8669 32.1786L23.6891 20.0009H23.6891L35.8669 7.82301C35.3416 7.14051 34.7671 6.48387 34.142 5.85863C33.5168 5.23348 32.8602 4.65887 32.1777 4.13379L19.9999 16.3115L19.9998 16.3116L7.82211 4.13379C7.13969 4.65895 6.48297 5.2334 5.85773 5.85863C5.2325 6.48387 4.65797 7.14051 4.13289 7.82301L16.3106 20.0007L16.3107 20.0007L4.13281 32.1786C4.65805 32.8611 5.23258 33.5178 5.85766 34.143C6.48289 34.7682 7.13945 35.3428 7.82203 35.8679L19.9998 23.6901L19.9999 23.69L32.1777 35.8678C32.8601 35.3426 33.5168 34.7681 34.142 34.1429C34.7673 33.5177 35.3417 32.8611 35.8669 32.1786Z"
        fill="#D80027"
      />
      <path
        d="M16.5215 6.08805L19.9998 6.95758L23.478 6.08805V3.13156L22.0867 3.82719L19.9998 1.74023L17.9128 3.82719L16.5215 3.13156V6.08805Z"
        fill="#FFDA44"
      />
      <path
        d="M16.5215 6.08691V8.26098C16.5215 10.9235 19.9998 11.7393 19.9998 11.7393C19.9998 11.7393 23.478 10.9234 23.478 8.26098V6.08691H16.5215Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111671">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default JerseySvg;
